export class UserAkModel {

  public UserName: string;
  public Token: string;

}



// WEBPACK FOOTER //
// ./src/app/models/user-ak.model.ts